/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ActionModel } from '../models/ActionModel';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class ActionService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns ActionModel
     * @throws ApiError
     */
    public actionGet(): Observable<Array<ActionModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/actions',
        });
    }
    /**
     * @param objectId
     * @returns ActionModel
     * @throws ApiError
     */
    public actionGetAvailableSiteActions(
        objectId: number,
    ): Observable<Array<ActionModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/actions/available/site/{objectId}',
            path: {
                'objectId': objectId,
            },
        });
    }
}
